import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useState } from 'react';

export default function LabeledTextField({ label, value, onChange, size, maxLength, multiline, minRows, helperText, error }) {
    const [isFocused, setIsFocused] = useState(false);
    const [hasFocused, setHasFocused] = useState(false);
    if (!size) {
        size = 12;
    }
    return (
        <Grid size={size}>
            <TextField
                label={label}
                value={value}
                onChange={onChange}
                inputProps={{ maxLength }}
                multiline={multiline}
                minRows={minRows}
                fullWidth
                error={!isFocused && hasFocused && error}
                helperText={helperText}
                onFocus={() => {
                    setIsFocused(true);
                    setHasFocused(true);
                }}
                onBlur={() => setIsFocused(false)}
            />
        </Grid>
    );
}